import { Mark } from '@tiptap/pm/model';
import Color from 'color';

export const cleanMark = (mark: Mark): Record<string, any> => {
  if (mark.type.name !== 'highlight') {
    return {};
  }

  if (mark.attrs['color']) {
    const col = Color(mark.attrs['color']).hex();
    return { color: col };
  }

  return {};
};
